import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { logPaymentMethodUpdateApi } from './logPaymentMethodUpdate.api'
import logPaymentMethodUpdateInitialState from './logPaymentMethodUpdate.initialState'
import {
  LogPaymentMethodUpdateErrorResponse,
  LogPaymentMethodUpdateRequestPayload
} from './logPaymentMethodUpdate.types'

export const logPaymentMethodUpdate = createAsyncThunk(
  urls.payments.logPaymentMethodUpdate,
  async (payload: LogPaymentMethodUpdateRequestPayload, { rejectWithValue }) => {
    const { onSuccess } = payload

    try {
      const response = await logPaymentMethodUpdateApi()

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const logPaymentMethodUpdateSlice = createSlice({
  name: urls.payments.logPaymentMethodUpdate,
  initialState: logPaymentMethodUpdateInitialState,
  reducers: {
    resetLogPaymentMethodUpdate: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(logPaymentMethodUpdate.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(logPaymentMethodUpdate.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(logPaymentMethodUpdate.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as LogPaymentMethodUpdateErrorResponse
        state.success = null
      })
  }
})

export const { actions: logPaymentMethodUpdateActions, reducer: logPaymentMethodUpdateReducer } =
  logPaymentMethodUpdateSlice
export const { resetLogPaymentMethodUpdate } = logPaymentMethodUpdateActions
export default logPaymentMethodUpdateSlice.reducer
